// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  AgendamentoRpa,
} from './';

export default {
  path: 'login-sap',
  name: 'Login sap',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'impersonate', name: 'Agendamento rpa', component: AgendamentoRpa },
  ],
};



// WEBPACK FOOTER //
// ./src/features/login-sap/route.js